import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CellClickedEvent, GridApi, GridOptions } from 'ag-grid-community';
import { AgActionCellRendererComponent, AgNumberCountComponent } from 'src/app/core/components';
import { AgActionCellLockRendererComponent } from 'src/app/core/components/grid-wrapper/helper/ag-action-cell-lock-renderer/ag-action-cell-lock-renderer.component';

@Component({
  selector: 'app-refresh-user-view-modal',
  templateUrl: './refresh-user-view-modal.component.html',
  styleUrls: ['./refresh-user-view-modal.component.css']
})
export class RefreshUserViewModalComponent implements OnInit {
    @Input() responseData: any; 
    
    gridAPI: GridApi;
    gridOptions: GridOptions = {
      animateRows: true,
      rowSelection: 'multiple',
      rowHeight: 40,
      headerHeight: 40,
      pagination: true,
      context: {
        componentParent: this 
      }
    };

  constructor(
    public activeModal: NgbActiveModal,
    // private logHelperService: LogHelperService,
    // private apiCall: DynamicApicallService,
  ) { }

  rowData1: any;
  rowData2: any;
  rowData3: any;
  rowData4: any;
  rowData5: any;

  ngOnInit() {
    this.rowData1 = this.responseData.Table1
    this.rowData2 = this.responseData.Table2
    this.rowData3 = this.responseData.Table3
    this.rowData4 = this.responseData.Table4
    this.rowData5 = this.responseData.Table5
  }

  columnDefs1 = [
      {
        headerName: "#",
        field: "sortCode",
        width: 50,
        sortable: false,
        suppressMenu: true,
        cellRendererFramework: AgNumberCountComponent,
      },
      {
        headerName: "Table Name",
        field: "Table Name",
        width: 150,
        sortable: true,
        filter: true,
        filterParams: { applyButton: true, clearButton: true },
      },
      {
        headerName: "Modify By",
        field: "ModifledBy",
        width: 150,
        sortable: true,
        filter: true,
        filterParams: { applyButton: true, clearButton: true },
      },
      {
        headerName: "Role Code",
        field: "Role_Code",
        width: 150,
        sortable: true,
        filter: true,
        filterParams: { applyButton: true, clearButton: true },
        tooltip: (params) => "Role Code",
        cellRenderer: function (params) {
          return (
            '<span class="hover-shadow">' +
            params.value +
            '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' +
            params.value +
            "></i> </span>"
          );
        },
        onCellClicked: (event: CellClickedEvent) => {
          const cellValue = event.value;
          if (navigator && navigator["clipboard"]) {
            navigator["clipboard"].writeText(cellValue).then(() => {
              console.log("Text copied to clipboard:", cellValue);
            });
          }
        },
      },
      {
        headerName: "PageAction RelationID",
        field: "PageActionRelationID",
        width: 150,
        sortable: true,
        filter: true,
        tooltip: (params) => "Copy User Name",
        filterParams: { applyButton: true, clearButton: true },
        cellRenderer: function (params) {
          return (
            '<span class="hover-shadow">' +
            params.value +
            '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' +
            params.value +
            "></i> </span>"
          );
        },
        onCellClicked: (event: CellClickedEvent) => {
          const cellValue = event.value;
          if (navigator && navigator["clipboard"]) {
            navigator["clipboard"].writeText(cellValue).then(() => {
              console.log("Text copied to clipboard:", cellValue);
            });
          }
        },
      },
      {
        headerName: "RoleApp Code",
        field: "RoleApp_Code",
        width: 150,
        sortable: true,
        filter: true,
        filterParams: { applyButton: true, clearButton: true },
        tooltip: (params) => "Copy Email",
      },
      {
        headerName: "Sys Code",
        field: "Sys_Code",
        width: 150,
        sortable: true,
        filter: true,
        filterParams: { applyButton: true, clearButton: true },
        tooltip: (params) => "Copy Email",
      },
    ];


  columnDefs2 = [
      {
        headerName: "#",
        field: "sortCode",
        width: 50,
        sortable: false,
        suppressMenu: true,
        cellRendererFramework: AgNumberCountComponent,
      },
      {
        headerName: "Table Name",
        field: "Table Name",
        width: 150,
        sortable: true,
        filter: true,
        filterParams: { applyButton: true, clearButton: true },
      },
      {
        headerName: "Priority",
        field: "Priority",
        width: 150,
        sortable: true,
        filter: true,
        filterParams: { applyButton: true, clearButton: true },
      },
      {
        headerName: "Role Code",
        field: "Role_Code",
        width: 150,
        sortable: true,
        filter: true,
        filterParams: { applyButton: true, clearButton: true },
        tooltip: (params) => "Role Code",
        cellRenderer: function (params) {
          return (
            '<span class="hover-shadow">' +
            params.value +
            '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' +
            params.value +
            "></i> </span>"
          );
        },
        onCellClicked: (event: CellClickedEvent) => {
          const cellValue = event.value;
          if (navigator && navigator["clipboard"]) {
            navigator["clipboard"].writeText(cellValue).then(() => {
              console.log("Text copied to clipboard:", cellValue);
            });
          }
        },
      },
      {
        headerName: "ID",
        field: "ID",
        width: 150,
        sortable: true,
        filter: true,
        tooltip: (params) => "Copy User Name",
        filterParams: { applyButton: true, clearButton: true },
        cellRenderer: function (params) {
          return (
            '<span class="hover-shadow">' +
            params.value +
            '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' +
            params.value +
            "></i> </span>"
          );
        },
        onCellClicked: (event: CellClickedEvent) => {
          const cellValue = event.value;
          if (navigator && navigator["clipboard"]) {
            navigator["clipboard"].writeText(cellValue).then(() => {
              console.log("Text copied to clipboard:", cellValue);
            });
          }
        },
      },
    ];

  columnDefs3 = [
      {
        headerName: "#",
        field: "sortCode",
        width: 50,
        sortable: false,
        suppressMenu: true,
        cellRendererFramework: AgNumberCountComponent,
      },
      {
        headerName: "Table Name",
        field: "Table Name",
        width: 150,
        sortable: true,
        filter: true,
        filterParams: { applyButton: true, clearButton: true },
      },
      {
        headerName: "Priority",
        field: "Priority",
        width: 150,
        sortable: true,
        filter: true,
        filterParams: { applyButton: true, clearButton: true },
      },
      {
        headerName: "Role Code",
        field: "Role_Code",
        width: 150,
        sortable: true,
        filter: true,
        filterParams: { applyButton: true, clearButton: true },
        tooltip: (params) => "Role Code",
        cellRenderer: function (params) {
          return (
            '<span class="hover-shadow">' +
            params.value +
            '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' +
            params.value +
            "></i> </span>"
          );
        },
        onCellClicked: (event: CellClickedEvent) => {
          const cellValue = event.value;
          if (navigator && navigator["clipboard"]) {
            navigator["clipboard"].writeText(cellValue).then(() => {
              console.log("Text copied to clipboard:", cellValue);
            });
          }
        },
      },
      {
        headerName: "ID",
        field: "ID",
        width: 150,
        sortable: true,
        filter: true,
        tooltip: (params) => "Copy User Name",
        filterParams: { applyButton: true, clearButton: true },
        cellRenderer: function (params) {
          return (
            '<span class="hover-shadow">' +
            params.value +
            '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' +
            params.value +
            "></i> </span>"
          );
        },
        onCellClicked: (event: CellClickedEvent) => {
          const cellValue = event.value;
          if (navigator && navigator["clipboard"]) {
            navigator["clipboard"].writeText(cellValue).then(() => {
              console.log("Text copied to clipboard:", cellValue);
            });
          }
        },
      },
    ];
  columnDefs4 = [
      {
        headerName: "#",
        field: "sortCode",
        width: 50,
        sortable: false,
        suppressMenu: true,
        cellRendererFramework: AgNumberCountComponent,
      },
      {
        headerName: "Table Name",
        field: "Table Name",
        width: 150,
        sortable: true,
        filter: true,
        filterParams: { applyButton: true, clearButton: true },
      },
      {
        headerName: "Plant Code",
        field: "Plant_Code",
        width: 150,
        sortable: true,
        filter: true,
        filterParams: { applyButton: true, clearButton: true },
      },
      {
        headerName: "User Code",
        field: "User_Code",
        width: 150,
        sortable: true,
        filter: true,
        filterParams: { applyButton: true, clearButton: true },
        tooltip: (params) => "Role Code",
        cellRenderer: function (params) {
          return (
            '<span class="hover-shadow">' +
            params.value +
            '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' +
            params.value +
            "></i> </span>"
          );
        },
        onCellClicked: (event: CellClickedEvent) => {
          const cellValue = event.value;
          if (navigator && navigator["clipboard"]) {
            navigator["clipboard"].writeText(cellValue).then(() => {
              console.log("Text copied to clipboard:", cellValue);
            });
          }
        },
      },
      {
        headerName: "Sys Code",
        field: "Sys_Code",
        width: 150,
        sortable: true,
        filter: true,
        tooltip: (params) => "Copy User Name",
        filterParams: { applyButton: true, clearButton: true },
        cellRenderer: function (params) {
          return (
            '<span class="hover-shadow">' +
            params.value +
            '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' +
            params.value +
            "></i> </span>"
          );
        },
        onCellClicked: (event: CellClickedEvent) => {
          const cellValue = event.value;
          if (navigator && navigator["clipboard"]) {
            navigator["clipboard"].writeText(cellValue).then(() => {
              console.log("Text copied to clipboard:", cellValue);
            });
          }
        },
      },
    ];
  columnDefs5 = [
      {
        headerName: "#",
        field: "sortCode",
        width: 50,
        sortable: false,
        suppressMenu: true,
        cellRendererFramework: AgNumberCountComponent,
      },
      {
        headerName: "Table Name",
        field: "Table Name",
        width: 150,
        sortable: true,
        filter: true,
        filterParams: { applyButton: true, clearButton: true },
      },
      {
        headerName: "User ID",
        field: "UserID",
        width: 150,
        sortable: true,
        filter: true,
        filterParams: { applyButton: true, clearButton: true },
      },
      {
        headerName: "User Name",
        field: "UserName",
        width: 150,
        sortable: true,
        filter: true,
        filterParams: { applyButton: true, clearButton: true },
        tooltip: (params) => "Role Code",
        cellRenderer: function (params) {
          return (
            '<span class="hover-shadow">' +
            params.value +
            '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' +
            params.value +
            "></i> </span>"
          );
        },
        onCellClicked: (event: CellClickedEvent) => {
          const cellValue = event.value;
          if (navigator && navigator["clipboard"]) {
            navigator["clipboard"].writeText(cellValue).then(() => {
              console.log("Text copied to clipboard:", cellValue);
            });
          }
        },
      },
      {
        headerName: "User Code",
        field: "UserCode",
        width: 150,
        sortable: true,
        filter: true,
        tooltip: (params) => "Copy User Name",
        filterParams: { applyButton: true, clearButton: true },
        cellRenderer: function (params) {
          return (
            '<span class="hover-shadow">' +
            params.value +
            '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' +
            params.value +
            "></i> </span>"
          );
        },
        onCellClicked: (event: CellClickedEvent) => {
          const cellValue = event.value;
          if (navigator && navigator["clipboard"]) {
            navigator["clipboard"].writeText(cellValue).then(() => {
              console.log("Text copied to clipboard:", cellValue);
            });
          }
        },
      },
      {
        headerName: "Alternet EmailID",
        field: "AlternetEmailID",
        width: 150,
        sortable: true,
        filter: true,
        tooltip: (params) => "Copy User Name",
        filterParams: { applyButton: true, clearButton: true },
        cellRenderer: function (params) {
          return (
            '<span class="hover-shadow">' +
            params.value +
            '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' +
            params.value +
            "></i> </span>"
          );
        },
        onCellClicked: (event: CellClickedEvent) => {
          const cellValue = event.value;
          if (navigator && navigator["clipboard"]) {
            navigator["clipboard"].writeText(cellValue).then(() => {
              console.log("Text copied to clipboard:", cellValue);
            });
          }
        },
      },
    ];


    onCloseAction() {
      this.activeModal.close(); 
    }
}
